module.exports = __webpack_public_path__ + "img/plan1.0b5478ec.png";